import { render, staticRenderFns } from "./serviceDescription.vue?vue&type=template&id=4668fcc5"
import script from "./serviceDescription.vue?vue&type=script&lang=js"
export * from "./serviceDescription.vue?vue&type=script&lang=js"
import style0 from "./serviceDescription.vue?vue&type=style&index=0&id=4668fcc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports